const Box = (props) => {

    return <>
        <div className="box w-full flex-col md:flex-row flex items-start gap-4">
            {props.children}
        </div>
    </>
}

export default Box;